import Vue from "vue"
import axios from "../plugins/axios"
Vue.prototype.$http = axios

const getDefaultState = () => {
  return {
    archived: false,
  }
}

const connexionFilter = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setArchived(state, value) {
      state.archived = value
    },
    resetState(state) {
      Object.assign(state, getDefaultState())
    },
  },
}

export default connexionFilter
